import { CustomEventWithDetail, Html, html, rune, UnsafeHtml, View } from 'rune-ts';
import klass from './ButtonCheckbox.module.scss';
import { InputCheckIcon } from '../Icon';
import { typoPcMo } from '../../../../shared/typography/typo';

export interface ButtonCheckboxProps {
  name: string;
  label?: string | UnsafeHtml | Html;
  bold_label?: boolean;
  disabled?: boolean;
  active?: boolean;
  is_mobile?: boolean;
  font_klass?: string;
  klass?: string;
  index?: number;
}

export class InputCheckboxChangeEvent extends CustomEventWithDetail<boolean> {}

class InputCheckbox extends View<ButtonCheckboxProps> {
  override template() {
    const { active, name, disabled } = this.data;

    return html`
      <input
        class="${klass.checkbox}"
        ${disabled ? 'disabled' : ''}
        ${active ? 'checked' : ''}
        type="checkbox"
        name="${name}"
      />
    `;
  }
}

export class ButtonCheckbox extends View<ButtonCheckboxProps> {
  inputCheckbox: InputCheckbox;

  constructor(data: ButtonCheckboxProps) {
    super(data);
    this.inputCheckbox = new InputCheckbox(this.data);
  }

  override template() {
    const { label, bold_label, font_klass } = this.data;
    const is_mobile = rune.getSharedData(this)?.is_mobile ?? !!this.data.is_mobile;
    return html`
      <label class="${klass.button_checkbox} ${this.data.klass ?? ''}">
        <span class="${klass.button_wrapper}">
          ${this.inputCheckbox}
          <span class="${klass.button}">
            <span class="${klass.check}">${InputCheckIcon}</span>
          </span>
          ${label
            ? html`<span
                class="${klass.label} ${font_klass ||
                typoPcMo({
                  is_mobile,
                  pc: bold_label ? '16_bold' : '16_medium',
                  mo: bold_label ? '14_bold' : '14_medium',
                })}"
                >${label}</span
              >`
            : ''}
        </span>
      </label>
    `;
  }

  protected override onRender() {
    this.delegate('change', InputCheckbox, this.changeActive);
  }

  private changeActive() {
    this.data.active = (this.inputCheckbox.element() as HTMLInputElement).checked;

    this.dispatchEvent(InputCheckboxChangeEvent, {
      bubbles: true,
      detail: this.data.active,
    });
  }

  activate() {
    if ((this.inputCheckbox.element() as HTMLInputElement).checked) {
      return;
    }

    (this.inputCheckbox.element() as HTMLInputElement).checked = true;
    this.data.active = true;
  }

  deactivate() {
    if (!(this.inputCheckbox.element() as HTMLInputElement).checked) {
      return;
    }

    (this.inputCheckbox.element() as HTMLInputElement).checked = false;
    this.data.active = false;
  }

  isChecked() {
    this.data.active = (this.inputCheckbox.element() as HTMLInputElement).checked;
    return this.data.active;
  }

  getName() {
    return this.data.name;
  }

  getIndex() {
    return this.data.index;
  }
}
